import sortBy from "lodash/sortBy";
import values from "lodash/values";

export const getFieldList = (fieldMap) => {
  return sortBy(values(fieldMap), "title");
};
